/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTemplateFolderEndpointRequest
 */
export interface CreateTemplateFolderEndpointRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateFolderEndpointRequest
     */
    group?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateFolderEndpointRequest
     */
    template: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateFolderEndpointRequest
     */
    path: string;
}

export function CreateTemplateFolderEndpointRequestFromJSON(json: any): CreateTemplateFolderEndpointRequest {
    return CreateTemplateFolderEndpointRequestFromJSONTyped(json, false);
}

export function CreateTemplateFolderEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTemplateFolderEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group': !exists(json, 'group') ? undefined : json['group'],
        'template': json['template'],
        'path': json['path'],
    };
}

export function CreateTemplateFolderEndpointRequestToJSON(value?: CreateTemplateFolderEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group': value.group,
        'template': value.template,
        'path': value.path,
    };
}


